/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteFeatureFlagPathParams = NonNullable<operations['deleteFeatureFlag']['parameters']['path']>;

export interface Input extends DeleteFeatureFlagPathParams {
  apiVersion?: string;
}

export async function deleteFeatureFlag(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/flags/{projectKey}/{featureFlagKey}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
